import React, { useContext, useState } from 'react';
import { motion } from 'framer-motion';

import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/FormElements/Button/Button';
import Modal from '../../shared/components/UIElements/Modal';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import './Interview.css';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';

const Evaluation = props => {

    const auth = useContext(AuthContext);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const {isLoading, error, sendRequest, clearError} = useHttpClient();


    const closeDeleteModalHandler = () => {
        setShowDeleteModal(false);
    };

    const confirmDeletionHandler = async () => {
        setShowDeleteModal(false);
        try {
            await sendRequest(process.env.REACT_APP_BACKEND_URL_PLAN+`/question/${props.id}/delete`, 'DELETE', null, {Authorization:'Bearer '+auth.token});
            props.onDelete(props.id);
        } catch (err) {

        }
    };

    return (
        <React.Fragment>
        <ErrorModal error={error} onClear={clearError} />
        <Modal
        show={showDeleteModal}
        onCancel={closeDeleteModalHandler}
        header="Are you sure?"
        footerClass="interview-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={closeDeleteModalHandler}>
              CANCEL
            </Button>
            <Button danger onClick={confirmDeletionHandler}>
              DELETE
            </Button>
          </React.Fragment>
        }
        >
            <p>The evaluation will be deleted forever. Do you still want to delete?</p>
        </Modal>
        <motion.li 
            className="interview-item"
            initial={{ opacity: 0, x: -1200 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.25+0.1*props.index, duration: 1 }}
        >
            <Card className="interview-item__content">
                {isLoading && <LoadingSpinner asOverlay />}
                    <Button to={`/question/report/evaluation/${props.id}`} transparent_100>
                    <h4>Evaluated at {new Date(props.dateCreated).toLocaleString()}</h4>
                    </Button>
            </Card>
        </motion.li>
        </React.Fragment>
        );
};

export default Evaluation;